/*
import {
  hf,
  hfDTM,
  _ht,
  cr,
  a,
  gs,
  ls,
  useCfmz,
  useLdrz,
  useMsgz,
  useSrpz,
  BoxC,
  BtnC,
  CbxC,
  GridC,
  MsgC,
  TextC,
} from 'lib';
*/
import * as BoxC from "./_ccbBoxC";
import * as TextC from "./_ccbTextC";
import * as GridC from "./_cccGridC";
import * as CbxC from "./_cccCbxC";
import * as BtnC from "./_cccBtnC";
import * as MsgC from "./_cccMsgC";
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as gs from "./_csGbl";
import * as ls from "./_csLcl"; // local state
import { useLdrz } from "./_csLdr";
import { useCfmz } from "./_csMdlCfm";
import { useMsgz } from "./_csMdlMsg";
import { useSrpz } from "./_csMdlSrp";
import * as _ht from './_ht';
import * as hf from './_hf';
import * as hfDTM from './_hfDTM';
import * as icm from './icm';
import * as ihd from './ihd';

import * as IccvCtt from './icvI1z___TzCtt';

export const N = (pz: {
  sPz: _ht.dz,
  cz: {
    i1zz: _ht.dz,
    i10rs:  _ht.ls,
    i17rs:  _ht.ls,
    _601s: _ht.ls,
  },
}) => {

  const _sDz = ls.useDz({
    bChk: false,
  })

  const _gStgz = gs.useStgz();
  const _gUserz = gs.useUserz();
  const _sMsgz = useMsgz();
  const _sLdrz = useLdrz();
  const _sCfmz = useCfmz();
  const _sSrpz = useSrpz();

  const _add = async () => {
    hf.udtDz(pz.cz.i1zz, {
      i1z1s: ihd.nd(pz.cz.i1zz.i1z1s), // checkbox の不要な _dlt を除く
    });
    // hf.l(`icvI1zD10Co2 69: ` + hf.s(pz.cz.i1zz.i1z5z))
    icm.saveI1zzAddAsync1({
      role: 'd',
      ctt: pz.sPz.crt.ctt,
      i1zz: pz.cz.i1zz,
      i10rs: pz.cz.i10rs,
      i17rs: pz.cz.i17rs,
      i15rs: [_gUserz.crt.i15rz],
      i18rz: _gUserz.crt.i18rz,
      hdys: pz.cz._601s,
      _31r_fst: pz.sPz.crt._31rz._fst,
      chkStep: 3,
      bfrAsync: () => new Promise<_ht.b>( _exit => {
//hf.l(`icvI1zD10Co2 53: here`);
        if (pz.sPz.crt.ctt == 'r' && _gUserz.crt.i19rz.i19ra2310i == 1) { // 電子決済を使用する場合
//hf.l(`icvI1zD10Co2 55: here`);
          _sSrpz.show({
            pmtType: 'once',
            _802t1100s: 'i19r',
            _802a1100k: _gUserz.crt.i19rz._key,
            _81rt1100s: 'i18r',
            _81ra1100k: _gUserz.crt.i18rz?._fst ?? -1,
            cmrName: _gUserz.crt.i18rz._pfx,
            pmtDrn: hfDTM.f(pz.cz.i1zz.i1zrz.i1zrd3100s, '年月日（曜）') + '利用分として',
            pmtAmt: pz.cz.i1zz.i1z3z.i1z3m4100i,
            atrScd: () => {
              hf.udtDz(pz.cz.i1zz.i1zrz, {
                i1zrs1100i: 90
              });
              hf.udtDz(pz.cz.i1zz.i1z3z, {
                i1z3s1100i: 40,
                i1z3t3100i: 20,
              });
              _sSrpz.hide();
              _exit(true);
            },
            onCls: () => {
              _exit(false);
            },
          });
        }
        else {
//hf.l(`icvI1zD10Co2 82: here`);
          _exit(true);
        }
      }),
      atrAsync: () => {
//hf.l(`icvI1zD10Co2 87: here`);
        pz.sPz.set({
          steps: [1, 2],
        });
      },
      sMsgz: _sMsgz,
      sLdrz: _sLdrz,
      sCfmz: _sCfmz,
      sPz: pz.sPz,
    });
  }

  return (

    cr.c(BoxC.N, {
      key: -10,
      abtType: 'baseAreaz',
      oClds: [

        cr.c(BoxC.N, {
          key: -10,
          abtType: 'topAreaz',
          oClds: [

            cr.c(TextC.N, {
              key: -10,
              abtType: 'wrn2z',
              textz: {
                pfx: `まだ${pz.sPz.crt.dffz.tgt}は確定していません。`,
              }
            })

          ]
        }),

        cr.c(BoxC.N, {
          key: -20,
          boxStlz: a('dw/f fd/rac mb/2'),
          abtType: 'msgAreaz',
          oClds: [

            cr.c(GridC.N, {
              key: -10,
              abtType: 'brdMsgz',
              lineCs: [
                {
                  cellCs: [
                    {
                      oClds: [
                        cr.c(TextC.N, {
                          key: -10,
                          textz: {
                            pfx:
                              cr.d('p') ? 
                                `★下の${pz.sPz.crt.dffz.tgt}内容と「施設・部屋情報」を確認の上、\n同意ボタンをチェックし、${pz.sPz.crt.dffz.tgt}を確定してください。`
                              : `★下の${pz.sPz.crt.dffz.tgt}内容と\n「施設・部屋情報」を確認の上、\n同意ボタンをチェックし、\n${pz.sPz.crt.dffz.tgt}を確定してください。`,
                            stlz: a('tb tc/rd5 ta/c ts/l'),
                          },
                        })
                      ]
                    }
                  ]
                }
              ]
            })

          ]
        }),

        cr.c(BoxC.N, {
          key: -30,
          abtType: 'mainAreaz',
          boxStlz: a(`sc/${pz.sPz.crt.dffz.clr}1`),
          oClds: [

            cr.c(IccvCtt.N, {
              key: -10,
              sPz: pz.sPz,
              boxStlz: a('mb/4'),
              cz: {
                i1zz: pz.cz.i1zz,
              }
            }),

            pz.sPz.crt.ctt == 'r' ?
            cr.c(GridC.N, {
              key: -20,
              abtType: 'brdWngz',
              boxStlz:
                cr.d('p') ?
                  a('dw/100 mb/4')
                : a('dw/f mb/4'),
              lineCs: [
                {
                  cellCs: [
                    {
                      oClds: [
                        cr.c(TextC.N, {
                          key: -10,
                          textz: {
                            pfx: '注意事項',
                            stlz: a(`tb tc/lt1`),
                          },
                        })
                      ]
                    }
                  ]
                },
                {
                  cellCs: [
                    {
                      oClds: [
                        cr.c(MsgC.N, {
                          key: -10,
                          abtType: 'wrn2z',
                          cz: {
                            ls: [
                              {
                                mkrCz: {
                                  textz: {
                                    pfx: '・',
                                  }
                                },
                                msgCz: {
                                  textz: {
                                    pfx: `予約確定後、ご利用日の${_gStgz.crt.S06010212}日前以降は、予約をキャンセルできません。`,
                                  }
                                },
                              },
                              {
                                mkrCz: {
                                  textz: {
                                    pfx: '・',
                                  }
                                },
                                msgCz: {
                                  textz: {
                                    pfx: 'ご利用がない場合も料金が発生します。',
                                  }
                                },
                              },
                              {
                                mkrCz: {
                                  textz: {
                                    pfx: '・',
                                  }
                                },
                                msgCz: {
                                  textz: {
                                    pfx: 'ご利用予定がなくなった場合は、必ず地区センターにご連絡ください。',
                                  }
                                },
                              }
                            ],
                          },
                        }),
                      ]
                    }
                  ]
                }
              ]
            })
            : null,

            cr.c(BtnC.N, {
              key: -30,
              boxStlz: a('mb/2'),
              abtType: 'fcyz',
              lblCz: {
                textz: {
                  pfx: '利用時間帯・料金・定員\n・各室詳細等の確認',
                  stlz: a(`ta/c`),
                },
              },
              pslPtyz: {
                onPress: () => {
                  cr.openUrl({
//                    url: icv.urlz.imn,
//                    url: _gUserz.crt.i191z.i191a1100s
                    url: pz.sPz.crt.i191z.i191a1100s
                  });
                },
              },
            }),

            cr.c(CbxC.SS, {
              key: -40,
              abtType: 'cfmz',
              boxStlz: a(`sc/${pz.sPz.crt.dffz.clr}5`),
              cz: {
                onChg: ( _n: _ht.n ) => {
                  _sDz.set({
                    bChk: _n == 1 ? true : false,
                  })
                }
              },
              cbxCz: {
                iconPtyz: {
                  sctz: a(`icc/lt9`),
                  nmlz: a(`icc/lt9`),
                }
              },
              lblCz: {
                textz: {
                  pfx: '「施設・部屋情報」を確認、同意します',
                  stlz: a(`tc/lt9`),
                }
              },
            }),

          ]
        }),

        cr.c(BoxC.N, {
          key: -40,
          abtType: 'btnAreaz',
          oClds: [

            cr.c(BtnC.N, {
              key: -10,
              abtType: 'backCmnz',
              boxStlz: a('dh/10 mb/2'),
              lblCz: {
                textz: {
                  pfx: `前の画面に戻る`,
                },
              },
              pslPtyz: {
                onPress: () => {
                  pz.sPz.set({
                    steps: [1, 0],
                  });
                },
              },
            }),

            cr.c(BtnC.N, {
              key: -20,
              abtType: 
                _sDz.crt.bChk ?
                'nextCmnz'
                : 'holdz',
              boxStlz: a('dh/10 mb/2'),
              lblCz: {
                textz: {
                  pfx: `この内容で${pz.sPz.crt.dffz.tgt}を確定`,
                },
              },
              pslPtyz: 
                _sDz.crt.bChk ?
                {
                  onPress: _add,
                }
                : null,
            }),

          ],
        })
      ]
    })
  );
};
